module.exports = __webpack_public_path__ + "static/media/speed.822c9160.svg";